import BaseApi from 'common/apiRequest/apis/BaseApi';
import { Request } from '../apiConcentrator/Audit';
import APINames from '../APINames';

class PersonalEventsApi extends BaseApi {
  public requestInstance = new Request(APINames.PERSONAL_EVENTS);
}
export default new PersonalEventsApi();
